theme.footerSection = (function () {
  function footer() {
    // Mobile navigation bar
    const mobileNavigateBar = document.querySelector(
      ".mobile__navigation--bar"
    );
    if (mobileNavigateBar) {
      document.documentElement.style.setProperty(
        "--mobile-navigation-bar-height",
        `${mobileNavigateBar.clientHeight}px`
      );

      window.addEventListener("resize", function () {
        document.documentElement.style.setProperty(
          "--mobile-navigation-bar-height",
          `${mobileNavigateBar.clientHeight}px`
        );
      });
    }
    // Footer widget column collapsible
    let accordion = true;
    const footerWidgetAccordion = function () {
      accordion = false;
      document
        .querySelectorAll(".footer__widget_toggle")
        .forEach(function (item) {
          item.addEventListener("click", function () {
            const footerWidget = this.closest(".footer__widget"),
              footerWidgetInner = footerWidget.querySelector(
                ".footer__widget_inner"
              );
            if (footerWidget.classList.contains("active")) {
              footerWidget.classList.remove("active");
              this.setAttribute("aria-expanded", "false");
              slideUp(footerWidgetInner);
            } else {
              footerWidget.classList.add("active");
              this.setAttribute("aria-expanded", "true");
              slideDown(footerWidgetInner);
              getSiblings(footerWidget.parentElement).forEach(function (item) {
                const footerWidget = item.querySelector(".footer__widget"),
                  footerWidgetInner = item.querySelector(
                    ".footer__widget_inner"
                  );
                const footerWidgetToggle = item.querySelector(
                  ".footer__widget_toggle"
                );
                if (!footerWidget || !footerWidgetInner) return;
                footerWidget.classList.remove("active");
                if (footerWidgetToggle) {
                  footerWidgetToggle.setAttribute("aria-expanded", "false");
                }
                slideUp(footerWidgetInner);
              });
            }
          });
        });
    };
    if (accordion) {
      footerWidgetAccordion();
    }
    window.addEventListener("resize", function () {
      document.querySelectorAll(".footer__widget").forEach(function (item) {
        if (window.outerWidth >= 750) {
          item.classList.remove("active");
          item.querySelector(".footer__widget_inner").style.display = "";
          const footerWidgetToggle = item.querySelector(
            ".footer__widget_toggle"
          );
          if (footerWidgetToggle) {
            footerWidgetToggle.setAttribute("aria-expanded", "true");
          }
        } else {
          const footerWidgetToggle = item.querySelector(
            ".footer__widget_toggle"
          );
          if (footerWidgetToggle && !item.classList.contains("active")) {
            footerWidgetToggle.setAttribute("aria-expanded", "false");
          }
        }
      });
      if (accordion) {
        footerWidgetAccordion();
      }
    });
  }
  return footer;
})();
